export default __webpack_public_path__ + "static/media/img5.8ee615f6.jpg";